import React from 'react';
import projectRoutes from './projects'

export default <React.Fragment>
  {projectRoutes}
</React.Fragment>